import React, {useState, useEffect} from 'react';
import photos from './photos';
import '../style/gallery.css';

export default function Gallery(props) {
  
  const [photo1, setPhoto1] = useState([]);
  const [photo2, setPhoto2] = useState([]);
  const [photo3, setPhoto3] = useState([]);
  const [imageWidth, setImageWidth] = useState(330);
  const [galleryFullScreen, setGalleryFullScreen] = useState({disp: false, src: ''});
  useEffect(() => {
    var p1 = [];
    var p2 = [];
    var p3 = [];
    photos.map((photo, index) => {
      if (index % 3 === 2) {
        p1.push(photo)
      }
      if (index % 3 === 1) {
        p2.push(photo)
      }
      if (index % 3 === 0) {
        p3.push(photo)
      }
      if (index === photos.length - 1) {
        setPhoto1(p1);
        setPhoto2(p2);
        setPhoto3(p3);
      }
      // console.log(window.screen.width)
      var w = 0;
      if (w === 0 && window.screen.width / 5 > 310) {w = window.screen.width / 5}
      if (w === 0 && window.screen.width / 4 > 310) {w = window.screen.width / 4}
      if (w === 0 && window.screen.width / 3 > 310) {w = window.screen.width / 3}
      if (w === 0 && window.screen.width / 2 > 310) {w = window.screen.width / 2}
      if (w === 0) {w = 300}
      setImageWidth(w);

      return 1;
    })

    return;
  }, [])
  return (
    <>
      <div className="gallery_container">
        <div className="gallery_disposition">
          <div className="gallery_content">
            {photo1.length > 0 && photo1.map((photo, index) => (
              <img
                className="image_style"
                key={'img' + index}
                onClick={() => setGalleryFullScreen({disp: true, src: photo.src})}
                src={process.env.PUBLIC_URL + '/' + photo.src}
                width={imageWidth}
                height={'auto'}
                alt={'photo' + index} />
            ))}
          </div>
          <div className="gallery_content">
            {photo2.length > 0 && photo2.map((photo, index) => (
              <img
                className="image_style"
                key={'img' + index}
                src={process.env.PUBLIC_URL + '/' + photo.src}
                width={imageWidth}
                height={'auto'}
                alt={'photo' + index} />
            ))}
          </div>
          <div className="gallery_content">
            {photo3.length > 0 && photo3.map((photo, index) => (
              <img
                className="image_style"
                key={'img' + index}
                src={process.env.PUBLIC_URL + '/' + photo.src}
                width={imageWidth}
                height={'auto'}
                alt={'photo' + index} />
            ))}
          </div>
        </div>
      </div>
    </>
  )
}
